import React from "react";

// Map of icon types to their visual representations
const iconMapping = {
  // Unit 1 icons
  baby: "👶",
  child: "👦",
  teen: "👨‍🎓",
  academy: "🏫",

  // Unit 2 icons
  shield: "🛡️",
  sword: "⚔️",
  horse: "🐴",
  graduate: "🎓",

  // Unit 3 icons
  map: "🗺️",
  forest: "🌲",
  mountain: "⛰️",
  oldman: "👴",

  // Unit 4 icons
  river: "🌊",
  fire: "🔥",
  dragon: "🐉",
  castle: "🏰",
};

const StoryMilestone = ({
  icon,
  achieved,
  size = 24,
  showTooltip,
  tooltipText,
}) => {
  // Get the actual emoji or use a question mark as fallback
  const displayIcon = iconMapping[icon] || "❓";

  return (
    <div className="story-milestone">
      <style jsx="true">{`
        .story-milestone {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: ${size}px;
          height: ${size}px;
          background-color: ${achieved ? "#ffffff" : "#e0e0e0"};
          border: 2px solid ${achieved ? "#ffb74d" : "#bdbdbd"};
          border-radius: 50%;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          font-size: ${size * 0.6}px;
        }

        .story-milestone:hover {
          transform: scale(1.2);
        }

        .milestone-tooltip {
          position: absolute;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: -5px;
          background-color: #333;
          color: white;
          padding: 5px 8px;
          border-radius: 4px;
          font-size: 12px;
          white-space: nowrap;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s ease, visibility 0.3s;
          font-family: "Inter", sans-serif;
          pointer-events: none;
          z-index: 15;
        }

        .story-milestone:hover .milestone-tooltip {
          opacity: 1;
          visibility: visible;
        }
      `}</style>
      {displayIcon}

      {showTooltip && tooltipText && (
        <div className="milestone-tooltip">{tooltipText}</div>
      )}
    </div>
  );
};

export default StoryMilestone;
